<template>
  <div>
    <!--   链接   -->
    <a-modal
        width="800px"
        v-model="isShowDialog"
        title="直播链接"
        @cancel="closeModel"
        :footer="null">
      <div class="link">
        <div style="font-weight: bold;padding: 20px">观众：</div>
        <div class="linkModal">
          <div class="title">前端观看链接 :</div>
          <div>
            <a-input v-model="linkLists.targetUrl" style="width: 400px" :disabled="true"/>
          </div>
          <div style="margin-left: 10px">
            <a-icon
                @click="copyText(linkLists.targetUrl)"
                style="color:#45a5e6;
                  font-size: 20px;
                  cursor: pointer"
                type="copy" />
          </div>
        </div>
        <div class="codeLink">
          <div class="title">观看链接二维码:</div>
          <div style="padding: 15px;border: 1px dashed #000;background-color: #fff;">
            <div id="qrCode">
            <vue-qr
                ref="image"
                :logo-src="logoSrc"
                :size="150"
                :margin="0"
                :auto-color="true"
                :dot-scale="1"
                :text="linkLists.targetUrl" />
            </div>
          </div>
          <div>
            <a-icon
                @click="copyImage"
                class="icon"
                type="copy" />
          </div>
          <div>
            <a-icon
                @click="downImg"
                class="icon"
                type="vertical-align-bottom" />
          </div>
        </div>
      </div>
      <div class="link">
        <div style="font-weight: bold;padding: 20px">推流：</div>
        <div class="linkModal">
          <div class="title">服务器链接 :</div>
          <div>
            <a-input v-model="linkLists.obsPushIp" style="width: 400px" :disabled="true"/>
          </div>
          <div style="margin-left: 10px">
            <a-icon
                @click="copyText(linkLists.obsPushIp)"
                style="color:#45a5e6;
                  font-size: 20px;
                  cursor: pointer"
                type="copy" />
          </div>
        </div>
        <div class="linkModal">
          <div class="title">串流密钥链接 :</div>
          <div>
            <a-input v-model="linkLists.obsPushName" style="width: 400px" :disabled="true"/>
          </div>
          <div style="margin-left: 10px">
            <a-icon
                @click="copyText(linkLists.obsPushName)"
                style="color:#45a5e6;
                  font-size: 20px;
                  cursor: pointer"
                type="copy" />
          </div>
        </div>
      </div>
      <div class="link">
        <div style="font-weight: bold;padding: 20px">拉流：</div>
        <div class="linkModal">
          <div class="title">rtmp链接 :</div>
          <div>
            <a-input v-model="linkLists.pullRtmpIp" style="width: 400px" :disabled="true"/>
          </div>
          <div style="margin-left: 10px">
            <a-icon
                @click="copyText(linkLists.pullRtmpIp)"
                style="color:#45a5e6;
                  font-size: 20px;
                  cursor: pointer"
                type="copy" />
          </div>
        </div>
        <div class="linkModal">
          <div class="title">flv链接 :</div>
          <div>
            <a-input v-model="linkLists.pullFlvIp" style="width: 400px" :disabled="true"/>
          </div>
          <div style="margin-left: 10px">
            <a-icon
                @click="copyText(linkLists.pullFlvIp)"
                style="color:#45a5e6;
                  font-size: 20px;
                  cursor: pointer"
                type="copy" />
          </div>
        </div>
        <div class="linkModal">
          <div class="title">m3u8链接 :</div>
          <div>
            <a-input v-model="linkLists.pullM3u8Ip" style="width: 400px" :disabled="true"/>
          </div>
          <div style="margin-left: 10px">
            <a-icon
                @click="copyText(linkLists.pullM3u8Ip)"
                style="color:#45a5e6;
                  font-size: 20px;
                  cursor: pointer"
                type="copy" />
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import VueQr from "vue-qr";

export default {
  name: "LinkPopup",
  components:{
    VueQr,
  },
  created() {
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.$store.state.isShowLink
      },
      set: function () {
      },
    },
    linkLists: {
      get: function () {
        return this.$store.state.linkList
      },
      set: function () {
      },
    },
  },
  data(){
    return{
      linkVisible:false,
      logoSrc:"",
    }
  },
  methods:{
    closeModel(){
      this.$store.dispatch('isShowLink',false);
    },
    //可以看到src并非url，而是base64字符串。base64转Blob：
    base64ToBlob(dataurl) {
      var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    copyText(value) {
      //创建input标签
      var input = document.createElement('input')
      //将input的值设置为需要复制的内容
      input.value = value;
      //添加input标签
      document.body.appendChild(input)
      //选中input标签
      input.select()
      //执行复制
      document.execCommand('copy')
      //成功提示信息
      this.$message.success('文本已复制到剪贴板!')
      //移除input标签
      document.body.removeChild(input)
    },
    //点击复制二维码
    copyImage() {
      let container = document.getElementById('qrCode').childNodes[0];
      let myBlob = this.base64ToBlob(container.getAttribute('src'));
      navigator.clipboard.write([
        new window.ClipboardItem({
          [myBlob.type]: myBlob
        })
      ]);
      this.$message.success("图片已复制到剪贴板！")
    },
    downImg(){
      let container = document.getElementById('qrCode').childNodes[0];

      let blob = this.base64ToBlob(container.getAttribute('src'));

      let aLink = document.createElement('a');

      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = '文件名';
      aLink.href = URL.createObjectURL(blob);
      aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));//兼容火狐
    },
  },
}
</script>

<style scoped lang="scss">
.link{
  background-color: #F2F2F2;
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.linkModal{
  display: flex;
  height: 50px;
  line-height: 50px;
.title{
  width: 120px;
  text-align: right;
  margin-right: 10px;
}

}
.codeLink{
  display: flex;margin-top: 20px;
.title{
  width: 120px;
  text-align: right;
  margin-right: 10px;
}
.icon{
  color:#45a5e6;font-size: 20px;margin-left: 10px;cursor: pointer;
}
}
</style>
